import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, adminApi } from "@/lib/api";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";

export default function AdminPage() {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    adminApi.setToken(token);
    api
      .get("/admin/state")
      .then(() => setAuthed(true))
      .catch(() => {
        localStorage.removeItem("admin_token");
        adminApi.setToken(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const handleLoginSuccess = (token) => {
    localStorage.setItem("admin_token", token);
    adminApi.setToken(token);
    setAuthed(true);
    toast.success("Login admin berhasil");
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    adminApi.setToken(null);
    setAuthed(false);
    navigate("/");
  };

  if (checking) {
    return (
      <div className="admin-theme flex items-center justify-center">
        <p className="text-slate-500">Memuat...</p>
      </div>
    );
  }

  return authed ? (
    <AdminDashboard onLogout={handleLogout} />
  ) : (
    <AdminLogin onSuccess={handleLoginSuccess} />
  );
}
